// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__NAjqv","tagList":"style_tagList__lza5u","article-ads":"style_article-ads__IJ7X1"};